<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center p-4" style="background-color: #fff !important;overflow: auto !important">
                <div>
                    <img src="/static/images/relay-race-baton@3x.png" style="height: 10rem !important" />
                    <div class="mt-5" style="font-size: 16px">
                        <div class="fw-600 mb-4" style="font-size: 20px; color: #005dae">Pass the baton</div>
                        Choose an owner before you
                        <span v-if="from == 'list'">become team member.</span>
                        <span v-else>leave the team.</span>
                    </div>
                    <div>
                        <multiselect
                        class="digi-multiselect approval-manager filter-multiple mt-2"
                            placeholder="Search and Add Member(s)" track-by="name"
                            label="name"
                            name="member"
                            v-validate="'required'"
                            v-model="member"
                            :options="members_options"
                            :multiple="false" :searchable="true" :internal-search="true"
                            :clear-on-select="true" :close-on-select="true" :options-limit="40"
                            :max-height="200" :show-no-results="true" :hide-selected="false"
                            :blockKeys="['Delete']">
                            <!-- <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.name }}</span>
                                    <span class="custom__remove pointer" @click="removeMemberTo(option)">
                                    <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template> -->
                            <!-- <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfCampaign" />
                            </template> -->
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                        </multiselect>
                        <div class="text-right pr-10">
                            <span class="float-left text-danger"
                                v-show="errors.has('member')">Please Select Member</span>
                        </div>
                    </div>
                    <div class="v-modal-footer mb-4" style="display: inline-block">
                        <div v-if="disableButtonAndDisplayLoader == false" class="d-flex  align-items-center justify-content-center ">
                            <button class="btn mt-5 new-cancel-button" @click="hideChooseOwner()" style="width: 110px">Cancel</button>
                            <button class="btn text-white mt-5 ml-6 bord-5px btn-secondary" @click="saveMember()">Make Owner</button>
                        </div>
                        <div v-else class="d-flex  align-items-center justify-content-center ">
                            <button class="btn mt-5 new-cancel-button" disabled style="width: 110px;border: 1px transparent !important">Cancel</button>
                            <button class="btn text-white mt-5 ml-6 bord-5px btn-secondary" disabled style="position: relative; border-radius: 5px !important;background-color: #E0E0E0 !important;color: #A6A6A6 !important;">Make Owner
                                <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    props: ["modal_name","from","members_list", "has_owner"],
    components: {
        HollowDotsSpinner,
    },
    data(){
        return{
            disableButtonAndDisplayLoader: false,
            member: '',
            members_options: [],
            showMemberAdded:false
        }
    },
    methods:{
        hideChooseOwner(){
            this.$emit('HidePassBatorModal')
        },
        saveMember(){
            this.$validator.validateAll().then(result =>{
                if(result){
                    this.disableButtonAndDisplayLoader = true;
                    if(this.has_owner){
                        this.$emit('DeleteOwner', this.member)
                        setTimeout(() => {
                            this.disableButtonAndDisplayLoader = false;
                            this.$modal.hide(this.modal_name);
                        }, 1500);
                    } else {
                        this.$emit('changeOwner', this.member)
                        setTimeout(() => {
                            this.disableButtonAndDisplayLoader = false;
                            this.$modal.hide(this.modal_name);
                        }, 1500);
                    }
                }
            })
        }
    },
    mounted(){
        this.members_list.forEach((el, el_index) => {
            if(el.role == 'member'){
                this.members_options.push(
                    {
                        id: el.id,
                        name: el.name
                    }
                )
            }
        })
    },
    computed:{

    }
}
</script>

<style scoped>
.btn-outline-primary{
    color: #00448b;
    background-color: transparent;
    border-radius: 5px;
    text-transform: none;
    font-weight: 500;
    border: 2px solid #00448b;
    line-height: 30px;
    box-shadow: none;
    padding-left: 30px;
    padding-right: 30px;
}
.bord-5px{
    border-radius: 5px !important;
    text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/components/alertModals/PassTheBaton.vue